export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Sort.vue?vue&type=template&id=47e0755c"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sort.vue?vue&type=template&id=47e0755c
// module id = 86
// module chunks = 0